var map = {
	"./Icon-create-default.svg": 1256,
	"./Logo-default.svg": 8313,
	"./add-circle.svg": 3494,
	"./app-photoshop.svg": 538,
	"./app-powerpoint.svg": 8033,
	"./apps-apple-icon.svg": 2155,
	"./apps-canva-icon.svg": 1720,
	"./apps-capture-icon.svg": 5761,
	"./apps-google-drive-icon.png": 9332,
	"./apps-msteams-icon.svg": 2577,
	"./apps-photoshop-icon.png": 4364,
	"./apps-playmarket-icon.svg": 4399,
	"./apps-powerpoint-embedded-icon.png": 7122,
	"./apps-powerpoint-presentation-icon.svg": 1843,
	"./arrow-down.svg": 400,
	"./arrow-org-admin.svg": 1108,
	"./arrow-right-to-left.svg": 5778,
	"./arrow-submenu.svg": 227,
	"./arrow_left.svg": 885,
	"./arrow_right.svg": 9800,
	"./back-arrow-modal.svg": 5229,
	"./back.svg": 6609,
	"./blank.svg": 4730,
	"./blogpost-round.svg": 4853,
	"./book.svg": 8391,
	"./calendar-mute.svg": 9208,
	"./calendar.svg": 7866,
	"./card-book.svg": 9924,
	"./card-play-icon.svg": 8265,
	"./card-play.svg": 6677,
	"./cb-accessories-tab-icon.svg": 5282,
	"./cb-base-tab-icon.svg": 9581,
	"./cb-branding-label.svg": 412,
	"./cb-branding-note.svg": 9470,
	"./cb-edit-logo-icon.svg": 8850,
	"./cb-face-tab-icon.svg": 4625,
	"./cb-name-edit-icon.svg": 8280,
	"./cb-outfit-tab-icon.svg": 2947,
	"./cb-remove-logo-icon.svg": 6790,
	"./character-builder.svg": 2475,
	"./check-new.svg": 2165,
	"./check.svg": 8080,
	"./checkbox-checkmark.svg": 2199,
	"./checkbox.svg": 3587,
	"./child-man.svg": 2249,
	"./child-woman.svg": 2619,
	"./classroom.svg": 6241,
	"./close.svg": 3692,
	"./closed-captions-icon.svg": 7990,
	"./color-palette.svg": 9451,
	"./company-templates.svg": 3915,
	"./contextual menu.svg": 6230,
	"./contextual-menu-hor.svg": 627,
	"./create-animated-video.svg": 2136,
	"./create-images-to-powtoon.svg": 3578,
	"./create-power-point-to-video.svg": 367,
	"./create-presentation.svg": 7393,
	"./create-record-video-message.svg": 5598,
	"./create-screen-recording.svg": 5919,
	"./create-stock-image-video.svg": 9923,
	"./create-video-infographics.svg": 3212,
	"./create-video-to-powtoon.svg": 5365,
	"./create-webinar-screen-presentations.svg": 3102,
	"./create-whiteboard-video.svg": 9778,
	"./crown-pink.svg": 7290,
	"./crown-round-border.svg": 5637,
	"./crown-white-big.svg": 3920,
	"./crown-white.svg": 6501,
	"./crown.svg": 2737,
	"./edit-doc.svg": 4789,
	"./edit-hollow.svg": 6008,
	"./edit.svg": 6812,
	"./empty-state-1.svg": 2813,
	"./empty-state.svg": 2859,
	"./exclamation-mark.svg": 7983,
	"./export.svg": 3370,
	"./exported-icon.png": 2998,
	"./eyedropper.svg": 2969,
	"./fail.svg": 9580,
	"./failed-icon.svg": 4427,
	"./fat-man.svg": 5062,
	"./fat-woman.svg": 3872,
	"./fat_blue_arrow.svg": 9726,
	"./filter.svg": 7318,
	"./folder-add.svg": 8290,
	"./folder.svg": 2876,
	"./font.svg": 7855,
	"./gift.svg": 1498,
	"./globe.svg": 2367,
	"./guest.svg": 2568,
	"./help.svg": 6297,
	"./home.svg": 6717,
	"./icon-cc-big.svg": 8451,
	"./import.svg": 6703,
	"./info.svg": 5140,
	"./insights-round.svg": 232,
	"./item-lock.svg": 5619,
	"./labs-round.svg": 27,
	"./learning-center-avatar-blog.svg": 9595,
	"./learning-center-avatar-tutorials.svg": 2836,
	"./learning-center-avatar-webinars.svg": 8194,
	"./left-nav-preview.svg": 1160,
	"./light-bulb-shines.svg": 7465,
	"./lock-animated.gif": 2029,
	"./lock-black.png": 5212,
	"./lock-black@2x.png": 3276,
	"./lock-pink.png": 4841,
	"./lock-pink@2x.png": 3467,
	"./lock-white.png": 7718,
	"./lock-white@2x.png": 9022,
	"./lock.svg": 3389,
	"./logo-powtoon.svg": 6548,
	"./manage-your-brand.svg": 1603,
	"./menu-assign.svg": 7421,
	"./menu-delete.svg": 6731,
	"./menu-download.svg": 1178,
	"./menu-duplicate.svg": 2229,
	"./menu-edit.svg": 8854,
	"./menu-export.svg": 2732,
	"./menu-group-legacy.svg": 9649,
	"./menu-group-mute.svg": 911,
	"./menu-group.svg": 1219,
	"./menu-more.svg": 4805,
	"./menu-move-to-folder.svg": 7970,
	"./menu-preview.svg": 102,
	"./menu-private-legacy.svg": 3109,
	"./menu-private.svg": 4991,
	"./menu-rename.svg": 5520,
	"./menu-select.svg": 3626,
	"./menu-send-copy.svg": 7510,
	"./menu-send-template.svg": 331,
	"./menu-submit.svg": 2402,
	"./microsoft-teams-logo.svg": 3655,
	"./mini-sound.svg": 7575,
	"./mini-voiceover.svg": 2214,
	"./more-3-dots.svg": 1980,
	"./more.svg": 4531,
	"./more_horiz.svg": 2204,
	"./mp4-icon.svg": 1005,
	"./neutral-tab.svg": 247,
	"./powtoon.svg": 4754,
	"./pptx-icon.svg": 9734,
	"./pptx-round.png": 5436,
	"./pptx-round@2x.png": 684,
	"./pptx-round@3x.png": 9943,
	"./preview-badge.svg": 9166,
	"./puzzle.svg": 3340,
	"./re-generate-icon.svg": 7765,
	"./regular-man.svg": 4847,
	"./regular-woman.svg": 7713,
	"./replace-logo-icon.svg": 9306,
	"./saturn.svg": 2237,
	"./search-chevron.svg": 8402,
	"./search-clear.svg": 724,
	"./search.svg": 9556,
	"./select-chevron.svg": 9833,
	"./set-as-template.svg": 4116,
	"./share-link-invite.svg": 5624,
	"./share-link.svg": 3294,
	"./share-with-team-link.svg": 7609,
	"./small-x.svg": 2902,
	"./sound-preview.svg": 6270,
	"./sound.svg": 4133,
	"./success-icon.svg": 2573,
	"./success.svg": 1705,
	"./template-empty-state.svg": 6926,
	"./templates.svg": 705,
	"./three-dots-hor.svg": 2777,
	"./three-dots-white.svg": 3765,
	"./timeline-sound.svg": 8259,
	"./timeline-voiceover.svg": 418,
	"./tour.svg": 6278,
	"./translation-icon.svg": 6605,
	"./translation.svg": 6793,
	"./tutorials.svg": 345,
	"./upload.svg": 8531,
	"./upload_white.svg": 4957,
	"./user-commenter.svg": 4964,
	"./user-commenter_dark.svg": 387,
	"./user-editor.svg": 6769,
	"./user-viewer.svg": 8168,
	"./user.svg": 6489,
	"./view-all.svg": 3333,
	"./voiceover-toaster.svg": 7539,
	"./warning-icon.png": 5553
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6494;